/**
 * Identidade no projeto PostHog único (INF-398).
 *
 * Os produtos da Principia passam a dividir um projeto PostHog. Sem namespace,
 * o UserId 123 deste app e o id 123 de outro produto viram a mesma person.
 * O prefixo é o mesmo dos serviços (helpers/posthog/identity.js nos ms_*):
 * `ppay:<UserId>` para aluno, `ppay-avalista:<GuarantorId>` para avalista.
 * Avalista nunca usa o UserId do aluno, senão as duas pessoas viram uma só.
 */

// Projeto de origem no PostHog Cloud: "Prod - Crédito Educacional" (dash.principia.net).
export const PRODUTO = 'credito'

const isPresent = (value) => value !== null && value !== undefined && value !== ''

export const userDistinctId = (UserId) => (isPresent(UserId) ? `ppay:${UserId}` : null)

export const guarantorDistinctId = (GuarantorId) => (isPresent(GuarantorId) ? `ppay-avalista:${GuarantorId}` : null)

// Valores atuais do PostHog Cloud. O cutover para o self-hosted troca só as
// variáveis REACT_APP_POSTHOG_KEY / REACT_APP_POSTHOG_HOST do build.
export const POSTHOG_CLOUD_KEY = 'phc_xezsjovH4ASvDk8DH8rF9PK4x35yFRcPkvCtaUhDnQYt'
export const POSTHOG_CLOUD_HOST = 'https://us.i.posthog.com'

export const resolvePosthogConfig = (env = process.env) => ({
  key: env.REACT_APP_POSTHOG_KEY || POSTHOG_CLOUD_KEY,
  host: env.REACT_APP_POSTHOG_HOST || POSTHOG_CLOUD_HOST
})
